import { LitElement, html, css } from "lit";
import { customElement, state } from "lit/decorators.js";
import { provide } from "@lit/context";

import { recordsContext } from "../contexts/records-context";

import { unzipData } from "../utils/unzip-data";

import "../components/auto-header";
import "../components/auto-info";
import "../components/auto-form";
import "../components/auto-nav";
import "../components/auto-footer";

@customElement("auto-home")
export class AutoHome extends LitElement {
  @state() private channel: BroadcastChannel;
  @provide({ context: recordsContext })
  @state()
  private _recordsData: Object;

  static styles = css`
    main {
      margin: 0;
      padding: 8px 16px;
    }
  `;

  connectedCallback() {
    super.connectedCallback();
    this.channel = new BroadcastChannel("auto");
    this.channel.postMessage("Testējam...");
    this._getData();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.data = null;
    this.channel.close();
  }

  async _getData() {
    try {
      this.channel.postMessage("Testējam...");
      this._recordsData = await unzipData("data.zip");
      if (!this._recordsData.success) {
        this.channel.postMessage("Kaut kas aizgāja pa pieskari ar datu kopu!");
        return;
      }
      this.channel.postMessage("Iegūstam datu kopu...");
      this.channel.postMessage(
        `Atrastas ${this._recordsData?.data.records.length} auto reģistrācijas`,
      );
    } catch (err) {
      console.error(err);
      this.channel.postMessage("Kaut kas aizgāja pa pieskari :(");
    }
  }

  render() {
    return html`
      <auto-header title="AUTO"></auto-header>
      <main>
        <auto-info></auto-info>
        <auto-form></auto-form>
      </main>
      <auto-nav></auto-nav>
    `;
  }
}
